(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/components/copy-row.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/components/copy-row.js');
"use strict";


const _React = React,
  useCallback = _React.useCallback;
const branding = svs.components.dialog.branding.SPORT;
const showCopiedDialog = () => {
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding,
    type: svs.components.dialog.type.DEFAULT,
    icon: 'thumbs-up',
    title: 'Texten har kopierats till Urklipp',
    actions: [{
      title: 'Okej'
    }]
  }));
};
const copyToClipboard = async value => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      showCopiedDialog();
      return;
    } catch (e) {
    }
  }
  const el = document.createElement('textarea');
  el.value = value;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  try {
    document.execCommand('copy');
    showCopiedDialog();
  } finally {
    document.body.removeChild(el);
  }
};
const CopyRow = _ref => {
  let copyValue = _ref.copyValue;
  const onClick = useCallback(() => copyToClipboard(copyValue), [copyValue]);
  const onFocus = useCallback(e => e.target.select(), []);
  return React.createElement("div", {
    className: "tt-matchlist-copy-container margin-top-1"
  }, React.createElement("span", null, "Externa Systemspel:"), React.createElement("input", {
    className: "std-input tt-input-copy",
    onFocus: onFocus,
    readOnly: true,
    tabIndex: -1,
    title: "Klistra in detta h\xF6gst upp i Externa Systemspels filen",
    value: copyValue
  }), React.createElement("button", {
    "aria-label": "Kopiera inledande kupongrad ".concat(copyValue, " till urklipp"),
    className: "btn btn-100 btn-transparent-default js-copy-button margin-left-1",
    onClick: onClick,
    title: "Kopiera inledande kupongrad till urklipp",
    type: "button"
  }, "Kopiera"));
};
setGlobal('svs.tt.components.CopyRow', CopyRow);

 })(window);